const BLOCKED_TERMS = [
  "fuck",
  "shit",
  "bitch",
  "cunt",
  "whore",
  "slut",
  "rape",
  "rapist",
  "nazi",
  "hitler",
  "kkk",
  "killyourself",
] as const

export type ModeratedTextErrorCode = "blocked_language"

function normalizeCompact(value: string) {
  return value
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "")
}

function normalizeTokens(value: string) {
  return value
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .trim()
    .toLowerCase()
    .split(/[^a-z0-9]+/g)
    .filter(Boolean)
}

export function findModeratedTerm(value: string): string | null {
  const compact = normalizeCompact(value)
  if (!compact) return null

  const tokens = new Set(normalizeTokens(value))
  for (const term of BLOCKED_TERMS) {
    if (tokens.has(term) || compact.includes(term)) return term
  }
  return null
}

export function getModeratedTextErrorCode(
  value: string,
): ModeratedTextErrorCode | null {
  return findModeratedTerm(value) ? "blocked_language" : null
}

export function validateModeratedText(
  value: string,
  label: string,
  errorFormatter?: (label: string) => string,
): string | null {
  if (!getModeratedTextErrorCode(value)) return null
  return errorFormatter
    ? errorFormatter(label)
    : `${label} contains blocked language.`
}
